import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LanguageUtils } from '../../utils/language.utils';
import { CountryResponse, ICountriesService } from './countries.interface';

@Injectable({
  providedIn: 'root'
})
export class CountriesService implements ICountriesService {
  cache = new Map<string, CountryResponse>();

  constructor(private httpClient: HttpClient) { }
  getCountries(): Observable<CountryResponse> {
    const cached = this.cache.get(LanguageUtils.getLanguage());
    if (cached) {
      return of(cached);
    } else {
      return this.httpClient.get<CountryResponse>(environment.apiPublicUrl + '/countries?language=' + LanguageUtils.getLanguage()).pipe(
        tap(data => this.cache.set(LanguageUtils.getLanguage(), data))
      );
    }
  }
}
